import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  buildBasketPayloadProducts,
  countsAsOwnUnit,
  getProductPriceTitle,
  resolveProductImage,
  routeToProduct,
} from '@/helpers'
import debounce from 'lodash/debounce'
import map from 'lodash/map'

export default {
  name: 'basket-item',
  props: {
    basketHasPromotion: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedCount: 1,
    }
  },
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      user: 'profile/user',
      promotionResponse: 'basket/promotionResponse',
      giftPayloadItems: 'gifts/giftPayloadItems',
    }),
    hasPromotion() {
      return false
      return this.product.select_type.hasActivePromotion || this.product.select_type.hasIndividualDiscount
    },
    checkBasketContainsPromotion() {
      return false
      return this.basket.findIndex((product) => product.select_type.hasActivePromotion || product.select_type.hasIndividualDiscount) !== -1
    },
    currentProductPrice() {
      return this.product.select_type.hasActivePromotion || this.product.select_type.hasIndividualDiscount
        ? this.product.select_type.oldPrice
        : this.product.select_type.price
    },
    // The units the customer chose themselves — including the 0.01 unit a
    // "third free" promotion split off, which is theirs, not an extra. Samplers
    // and sale gifts are the backend's own rows and stay out.
    totalCount() {
      return this.basket
        .filter(
          (item) =>
            countsAsOwnUnit(item, this.basket) &&
            item.id === this.product.id &&
            item.select_type.id === this.product.select_type.id,
        )
        .reduce((sum, item) => sum + item.select_count, 0)
    },
  },
  async created() {
    await this.fetchPromotionData()
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      setCount: 'basket/SET_POSITION_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
    }),

    ...mapActions({
      fetchPromotion: 'basket/FETCH_PROMOTION',
      removeSelectedGift: 'gifts/REMOVE_SELECTED_GIFT',
    }),

    fetchPromotionData: debounce(async function () {
      const payload = {
        products: buildBasketPayloadProducts(this.basket, this.giftPayloadItems),
      }

      try {
        await this.fetchPromotion(payload)
      } catch (e) {
        console.error(e)
      }
    }, 500),
    isSample(product) {
      return product.type === 'sampler' && product.allProductSum / product.select_count === 0.01
    },
    allowedProductManipulations(product) {
      return !product.isPresent && !product.isAddedFromSale && !this.isSample(product)
    },

    findCurrentProductPromotionBanner(id) {
      if (!this.promotionResponse || !this.promotionResponse.closestSales) return null

      const promotion = this.promotionResponse.closestSales.find((promo) => promo.productPricesToApply.includes(id))

      return promotion || null
    },

    async changeCount(type, count = 1) {
      let nextCount = this.totalCount

      if (type === 'increment') {
        nextCount = this.totalCount + 1
      } else if (type === 'decrement') {
        nextCount = this.totalCount - 1
      } else {
        if (!count) return
        nextCount = parseInt(count)
      }

      if (!nextCount || nextCount < 1) return

      this.setCount({
        product: this.product,
        select_count: nextCount,
      })
      await this.fetchPromotionData()
    },

    async handleRemove(item) {
      if (item.isFree) {
        await this.removeSelectedGift({
          productPriceId: item.select_type?.id,
          saleId: item.saleId ?? null,
        })
      }
      this.remove(item)
      await this.fetchPromotionData()
    },
  },
}
